import React from "react";
import Footer from "./Footer";
import FooterBottom from "./FooterBottom";

export default function FooterMain() {
  return (
    <>
      <Footer />
      <FooterBottom />
    </>
  );
}
